import script from "./InfraestruturaCloudSecurity.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfraestruturaCloudSecurity.vue?vue&type=script&setup=true&lang=ts"

import "./InfraestruturaCloudSecurity.vue?vue&type=style&index=0&id=2faeaa96&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2faeaa96"]])

export default __exports__